import { useCallback, useReducer, type Reducer } from 'react'

export type EditSingleFieldState = {
    linkId: number
    field: 'name' | 'budget'
} | null

export type EditSingleFieldAction =
    | { type: 'set'; payload: EditSingleFieldState }
    | { type: 'reset' }

export const editSingleFieldReducer: Reducer<
    EditSingleFieldState,
    EditSingleFieldAction
> = (_state, action) => {
    switch (action.type) {
        case 'set': {
            return action.payload
        }
    }

    return null
}

export const useEditSingleField = () => {
    const [state, dispatch] = useReducer(editSingleFieldReducer, null)

    return { editSingleFieldDispatch: dispatch, editSingleField: state }
}

export type UseEditSingleField = ReturnType<typeof useEditSingleField>

export const useEditSingleFieldBounded = (
    dispatch: UseEditSingleField['editSingleFieldDispatch'],
    linkId: number
) => {
    const onChangeEditName = useCallback(
        (v: boolean) =>
            dispatch(
                v
                    ? {
                          type: 'set',
                          payload: { linkId, field: 'name' },
                      }
                    : { type: 'reset' }
            ),
        [dispatch, linkId]
    )

    const onChangeEditBudget = useCallback(
        (v: boolean) =>
            dispatch(
                v
                    ? {
                          type: 'set',
                          payload: { linkId, field: 'budget' },
                      }
                    : { type: 'reset' }
            ),
        [dispatch, linkId]
    )

    return { onChangeEditName, onChangeEditBudget }
}
